import { actions } from '@app/store/action/invoices';

export default function (state = {}, action) {
  const { type } = action;

  switch (type) {
    case actions.GET_INVOICES:
      return {
        ...state,
        list: action.details,
      };
  }

  return state;
}
